export const STOOPING = 'stooping'
export const COMFORTING = 'comforting'
export const ARGUING = 'arguing'
